import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import './DashboardPage.css';
import { Bar, Doughnut, Line } from 'react-chartjs-2';
import Chart from 'chart.js/auto';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    Title,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels'; // Ensure this is imported at the top
import SalesOverviewCard from '../src/cards/SalesOverviewCard';
import { Container, Grid, Box, Typography, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import DailySalesOverviewCard from './cards/DailySalesOverviewCard';
import MonthlySalesOverviewCard from './cards/MonthlySalesOverviewCard';
import ReactSelect, { components } from 'react-select';
import { formatCurrency } from './utilities/formatCurrency';
import PlaceholderImage from './assets/placeholder.svg';
const userRole=localStorage.getItem('role');


const CustomOption = (props) => {
    return (
        <components.Option {...props}>
            <input type="checkbox" checked={props.isSelected} onChange={() => {}} style={{ marginRight: '8px' }} />
            {props.label}
        </components.Option>
    );
};

const isMobile = window.innerWidth <= 768

// Register Chart.js plugins and elements
ChartJS.register(ArcElement, Tooltip, Legend, Title, ChartDataLabels);
const customTextPlugin = {

    id: 'customTextPlugin', // Unique plugin ID
    beforeDraw: (chart) => {
        if (chart.config.type === 'doughnut'){
        const { width, height, ctx } = chart; // Access chart properties
        ctx.save(); // Save the context's state
        ctx.font = '20px Arial'; // Set the font size and family
        ctx.textAlign = 'center'; // Center align text horizontally
        ctx.textBaseline = 'middle'; // Center align text vertically
        ctx.fillStyle = '#333'; // Text color

         // Dynamically calculate total sales based on visible data
         const dataset = chart.data.datasets[0];
         const meta = chart.getDatasetMeta(0); // Get metadata for the first dataset
           // Use counts instead of revenue
        const counts = dataset.counts || [];
        //  console.log("chart.data",counts)
        
         // Filter only visible data points (hidden data points are excluded)
         const visibleData = counts.filter((_, index) => !meta.data[index].hidden);
        //  console.log("visibleData",visibleData)
        const totalSales = visibleData.reduce((sum, value) => sum + value, 0);
        console.log("totalSales",totalSales)
       
        // const totalSales = chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
       // Adjust the position of the text
       const x = width / 2; // Center horizontally
       const y = height / 1.8; // Adjust for half-donut cutout

       // Draw the text
       ctx.fillText('Total Sales', x, isMobile?y-50:y-15);
       ctx.fillText(totalSales,x,isMobile?(y-20):(y+15))
        ctx.restore(); // Restore the context's state
    }
    },
};
ChartJS.register(customTextPlugin);





const DashboardPage = () => {
    const [salesEntries, setSalesEntries] = useState([]);
    const [error, setError] = useState('');
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString());
    const [selectedMonth, setSelectedMonth] = useState('');
    const [loading, setLoading] = useState(true);
    const [selectedHospitalYear, setSelectedHospitalYear] = useState('ALL');
    
    const [selectedHospitalMonth, setSelectedHospitalMonth] = useState('');
    const [testselectedYear, testsetSelectedYear] = useState('ALL');
        const [testselectedMonth, testsetSelectedMonth] = useState('');
        const [fromDate, setFromDate] = useState("");
const [toDate, setToDate] = useState("");
    const [selectedSalesByRegionYear, setSelectedSalesByRegionYear] = useState('ALL');
     const [selectedSalesByRegionMonth, setSelectedSalesByRegionMonth] = useState('');
     const [selectedSalesBySalesPersonYear, setSelectedSalesBySalesPersonYear] = useState('ALL');
     const [selectedSalesBySalesPersonMonth, setSelectedSalesBySalesPersonMonth] = useState('');
     const [chartType, setChartType] = useState('bar');
    const [regionalComparisonYear, setRegionalComparisonYear] = useState('ALL');
    const [regionalComparisonMonth, setRegionalComparisonMonth] = useState('');
    const [selectedRegions, setSelectedRegions] = useState([]);
    const [regionError, setRegionError] = useState('');
    const [regionLabelMapFromAPI, setRegionLabelMapFromAPI] = useState({});


const colors = [
    '#1e3c72', // Dark Navy
    '#2a5298', // Navy Blue
    '#34d399', // Teal Green
    '#0891b2', // Cyan Teal
    '#0f766e', // Dark Teal
    '#14b8a6', // Turquoise
    '#06b6d4', // Sky Cyan
    '#0369a1', // Deep Sky
    '#1e40af', // Deep Blue
    '#1e3a8a', // Navy Dark
    '#1f2937', // Dark Gray
    '#374151', // Medium Gray
    '#4b5563', // Gray Blue
    '#06b6d4', // Bright Cyan
    '#10b981', // Emerald
    '#059669', // Dark Emerald
    '#0d9488', // Teal Dark
    '#0f766e', // Teal Darker
    '#115e59', // Teal Darkest
    '#134e4a', // Deep Teal
    '#083344', // Navy Teal
    '#0c4a6e', // Navy
    '#082f49', // Very Dark Navy
    '#1e293b', // Slate
    '#334155', // Slate Medium
    '#475569', // Slate Dark
    '#64748b', // Slate Gray
];

const comparisonColors = ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0'];

    useEffect(() => {
        const fetchSalesEntries = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/sales/dashboard`, {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    },
                    
                        params:{
                            fromDate,
                            toDate
                        }
                    
                });
                setSalesEntries(response.data);

            } catch (error) {
                 if (error.response?.data?.logout === true) {
        localStorage.removeItem('token');
        window.location.href = '/login'; // 🔥 auto logout
        return;
      }
                setError('Failed to fetch sales entries');
                console.error('Error:', error);
                
            } finally {
                setLoading(false);
            }
        };

        fetchSalesEntries();
    }, [fromDate,toDate]);

    // Fetch region label map from backend
    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/api/mappings`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            })
            .then((res) => {
                const mappings = res.data?.regionMappings || [];
                console.log('Fetched region mappings (raw):', res.data);
                console.log('Fetched region mappings:', mappings);
             
                // Build { regionCode: regionName }
                // salesentries.RegionalCodeId == regionalcodes.RegionalCodeID == regionalcodes.Code == regional_email_mappings.regionCode
                const map = {};
                mappings.forEach((m) => {
                    if (m.regionCode != null && m.regionName) {
                        map[Number(m.regionCode)] = m.regionName;
                    }
                });
                setRegionLabelMapFromAPI(map);
            })
            .catch((err) => console.error('Failed to fetch region mappings:', err));
    }, []);
    // console.log("dashboard",salesEntries)

    // Calculate total sales, total amount, and total tests
    const totalSales = salesEntries.length;
    const totalAmount = salesEntries.reduce((total, entry) => total + (parseFloat(entry.Amount) || 0)-(parseFloat(entry?.RefundDetails?.RefundAmount)||0), 0);
    const totalTests = salesEntries.reduce((total, entry) => total + (entry.tests?.length || 0), 0);

    const getFilteredData = () => {
        return salesEntries.filter(entry => new Date(entry.createdAt).getFullYear().toString() === selectedYear);
    };

    const today = new Date();
    const todaySalesEntries = salesEntries.filter(entry => {
    const entryDate = new Date(entry.createdAt);
    return (
        entryDate.getFullYear() === today.getFullYear() &&
        entryDate.getMonth() === today.getMonth() &&
        entryDate.getDate() === today.getDate()
      );
    });

    const todaySales = todaySalesEntries.length;
    const todayAmount = todaySalesEntries.reduce((total, entry) => total + (parseFloat(entry.Amount) || 0)-(parseFloat(entry?.RefundDetails?.RefundAmount)||0), 0);
    const todayTests = todaySalesEntries.reduce((total, entry) => total + (entry.tests?.length || 0), 0);

    // Get Current Month Sales, Amount, and Tests
    const currentMonth = new Date().getMonth();
    const currentYear = new Date().getFullYear();

    const currentMonthSalesEntries = salesEntries.filter(entry => {
        const entryDate = new Date(entry.createdAt);
        return (
            entryDate.getFullYear() === currentYear &&
            entryDate.getMonth() === currentMonth
        );
    });

    const currentMonthSales = currentMonthSalesEntries.length;
    const currentMonthAmount = currentMonthSalesEntries.reduce((total, entry) => total + (parseFloat(entry.Amount) || 0)-(parseFloat(entry?.RefundDetails?.RefundAmount)||0), 0);
    const currentMonthTests = currentMonthSalesEntries.reduce((total, entry) => total + (entry.tests?.length || 0), 0);

    // Yesterday's Sales
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const yesterdaySalesEntries = salesEntries.filter(entry => {
        const entryDate = new Date(entry.createdAt);
        return (
            entryDate.getFullYear() === yesterday.getFullYear() &&
            entryDate.getMonth() === yesterday.getMonth() &&
            entryDate.getDate() === yesterday.getDate()
        );
    });
    const yesterdaySales = yesterdaySalesEntries.length;
    const yesterdayAmount = yesterdaySalesEntries.reduce((total, entry) => total + (parseFloat(entry.Amount) || 0) - (parseFloat(entry?.RefundDetails?.RefundAmount) || 0), 0);

    // Previous Month's Sales
    const lastMonth = new Date();
    lastMonth.setMonth(lastMonth.getMonth() - 1);
    const todayDayOfMonth = today.getDate();

    // Full last month (for display)
    const lastMonthSalesEntries = salesEntries.filter(entry => {
        const entryDate = new Date(entry.createdAt);
        return (
            entryDate.getFullYear() === lastMonth.getFullYear() &&
            entryDate.getMonth() === lastMonth.getMonth()
        );
    });
    const lastMonthSales = lastMonthSalesEntries.length;
    const lastMonthAmount = lastMonthSalesEntries.reduce((total, entry) => total + (parseFloat(entry.Amount) || 0) - (parseFloat(entry?.RefundDetails?.RefundAmount) || 0), 0);

    // Same period last month (day 1 → same day as today) — used for fair % comparison
    const lastMonthSamePeriodEntries = salesEntries.filter(entry => {
        const entryDate = new Date(entry.createdAt);
        return (
            entryDate.getFullYear() === lastMonth.getFullYear() &&
            entryDate.getMonth() === lastMonth.getMonth() &&
            entryDate.getDate() <= todayDayOfMonth
        );
    });
    const lastMonthSamePeriodSales = lastMonthSamePeriodEntries.length;
    const lastMonthSamePeriodAmount = lastMonthSamePeriodEntries.reduce((total, entry) => total + (parseFloat(entry.Amount) || 0) - (parseFloat(entry?.RefundDetails?.RefundAmount) || 0), 0);

    // Percentage Change Calculation
    const calculatePercentageChange = (current, previous) => {
        if (previous === 0) {
            return current > 0 ? 100 : 0;
        }
        return ((current - previous) / previous) * 100;
    };

    const dailySalesPercentageChange = calculatePercentageChange(todaySales, yesterdaySales);
    const dailyAmountPercentageChange = calculatePercentageChange(todayAmount, yesterdayAmount);
    const monthlySalesPercentageChange = calculatePercentageChange(currentMonthSales, lastMonthSamePeriodSales);
    const monthlyAmountPercentageChange = calculatePercentageChange(currentMonthAmount, lastMonthSamePeriodAmount);

    const getFilteredEntriesForDay = () => {
        return salesEntries.filter(entry => {
            const entryDate = new Date(entry.createdAt);
            const entryYear = entryDate.getFullYear().toString();
            const entryMonth = (entryDate.getMonth() + 1).toString().padStart(2, '0'); // Add leading zero
    
            return entryYear === selectedYear && entryMonth === selectedMonth;
        });
    }

    const calculateMonthlySales = (filteredEntries) => {
        const monthlySalesCount = {};
        for (let i = 1; i <= 12; i++) {
            const monthKey = `${selectedYear}-${i < 10 ? '0' + i : i}`;
            monthlySalesCount[monthKey] = {count:0,totalAmount:0};
        }
        for (let entry of filteredEntries) {
            const date = new Date(entry.createdAt);
            const monthKey = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}`;


            monthlySalesCount[monthKey].count++;
            monthlySalesCount[monthKey].totalAmount+=parseFloat(entry.Amount)||0;
            monthlySalesCount[monthKey].totalAmount-=(parseFloat(entry?.RefundDetails?.RefundAmount)||0)||0;
        }
        return monthlySalesCount;
    };
   

    const calculateDailySales = (filteredEntries) => {
        const dailySalesCount = {};
        const daysInMonth = new Date(selectedYear, selectedMonth, 0).getDate(); // Get the total days in the selected month
        for (let day = 1; day <= daysInMonth; day++) {
            const dayKey = `${selectedYear}-${selectedMonth.padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
            dailySalesCount[dayKey] = 0;
        }

        for (let entry of filteredEntries) {
            const date = new Date(entry.createdAt);
            const dayKey = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
            if (dailySalesCount[dayKey] !== undefined) {
                dailySalesCount[dayKey]++;
            }
        }
        console.log('Daily Sales Count:', dailySalesCount);
        return dailySalesCount;
    };


    // Group sales entries by RegionalCodeId
    // const groupSalesByRegionalCode = () => {
    // const regionalSales = salesEntries.reduce((acc, entry) => {
    //     const regionalCodeIdRaw = entry.RegionalCodeId;
    //      const regionalCodeId = regionLabelMap[regionalCodeIdRaw] ? regionalCodeIdRaw : 10;
    //     // Initialize if it doesn't exist
    //     if (!acc[regionalCodeId]) {
    //         acc[regionalCodeId] = {
    //             count: 0, 
    //             amount: 0
    //         };
    //     }
    //     // Increment the count and amount
    //     acc[regionalCodeId].count++;
    //     acc[regionalCodeId].amount += parseFloat(entry.Amount) || 0;
    //     acc[regionalCodeId].amount -= parseFloat(entry?.RefundDetails?.RefundAmount) || 0;

    //     return acc;
    // }, {});

    // const sortedArray = Object.entries(regionalSales)
    //     .sort(([, a], [, b]) => b.count - a.count)
    //     .map(([key,value])=>({
    //         codeId:key,
    //          regionName: regionLabelMap[Number(key)] || regionLabelMap[10],
    //         count:value.count,
    //         amount:value.amount})); // Sorting key-value pairs by count

    // console.log("After Sorting (Array):", JSON.stringify(sortedArray));
   



    //     return sortedArray;
    // };

    const groupSalesByRegionalCode = () => {
  const merged = salesEntries.reduce((acc, entry) => {
    const codeId = Number(entry.RegionalCodeId);
    const regionName = regionLabelMap[codeId] || 'Rest of India';

    if (!acc[regionName]) {
      acc[regionName] = {
        regionName,
        codeIds: new Set(),
        count: 0,
        amount: 0
      };
    }

    acc[regionName].codeIds.add(codeId);
    acc[regionName].count += 1;

    const amount = Number(entry.Amount) || 0;
    const refund = Number(entry?.RefundDetails?.RefundAmount) || 0;
    acc[regionName].amount += (amount - refund);

    return acc;
  }, {});

  return Object.values(merged).map(item => ({
    regionName: item.regionName,
    codeIds: Array.from(item.codeIds), // [1,3,6]
    count: item.count,
    amount: item.amount
  })).sort((a,b)=>b.amount-a.amount)
};

    
    const regionLabelMap = regionLabelMapFromAPI;

const uniqueRegions = useMemo(
  () => [...new Set(Object.values(regionLabelMap))],
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [regionLabelMapFromAPI]
);

    const regionalComparisonChartData = useMemo(() => {
    let filteredSales = salesEntries;

    if (regionalComparisonYear !== 'ALL') {
        filteredSales = filteredSales.filter(e => new Date(e.createdAt).getFullYear().toString() === regionalComparisonYear);
    }

    if (regionalComparisonMonth) {
        filteredSales = filteredSales.filter(e => (new Date(e.createdAt).getMonth() + 1).toString().padStart(2, '0') === regionalComparisonMonth);
    }

    const regionIdMap = {};
    for (const id in regionLabelMap) {
        const name = regionLabelMap[id];
        if (!regionIdMap[name]) {
            regionIdMap[name] = [];
        }
        regionIdMap[name].push(id.toString());
    }

    let labels = [];
    let getGroupKey;

    if (regionalComparisonMonth && regionalComparisonYear !== 'ALL') {
        const daysInMonth = new Date(regionalComparisonYear, regionalComparisonMonth, 0).getDate();
        labels = Array.from({ length: daysInMonth }, (_, i) => (i + 1).toString());
        getGroupKey = (date) => date.getDate().toString();
    } else if (regionalComparisonYear !== 'ALL') {
        labels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        getGroupKey = (date) => labels[date.getMonth()];
    } else {
        labels = [...new Set(salesEntries.map(e => new Date(e.createdAt).getFullYear().toString()))].sort();
        getGroupKey = (date) => date.getFullYear().toString();
    }

    const datasets = selectedRegions.map((region, index) => {
        const regionIds = regionIdMap[region.value] || [];
        const regionSales = filteredSales.filter(e => regionIds.includes(e.RegionalCodeId.toString()));

        const salesByTime = regionSales.reduce((acc, entry) => {
            const date = new Date(entry.createdAt);
            const key = getGroupKey(date);
            const amount = (parseFloat(entry.Amount) || 0) - (parseFloat(entry?.RefundDetails?.RefundAmount) || 0);
            if (!acc[key]) {
                acc[key] = 0;
            }
            acc[key] += amount;
            return acc;
        }, {});

        const data = labels.map(label => salesByTime[label] || 0);

        return {
            label: region.value,
            data: data,
            borderColor: comparisonColors[index % comparisonColors.length],
            backgroundColor: comparisonColors[index % comparisonColors.length] + '33',
            fill: false,
        };
    });

    return { labels, datasets };
}, [salesEntries, regionalComparisonYear, regionalComparisonMonth, selectedRegions, regionLabelMap]);

// Grouped sales by RegionalCodeId
// const regionalSalesData = groupSalesByRegionalCode();
// console.log("regionalSalesData1",regionalSalesData)
// const regionalLabels=regionalSalesData.map(item=>item.regionName)
// console.log("regionalLabels1",regionalLabels)
// // const regionalLabels = Object.keys(regionalSalesData).map(codeId => regionLabelMap[codeId]||`Region ${codeId}`);
// const regionalSalesCounts = Object.values(regionalSalesData).map(data => data.count);
// const regionalSalesRevenue=Object.values(regionalSalesData).map(data=>data.amount);



    const years = [...new Set(salesEntries.map(entry => new Date(entry.createdAt).getFullYear().toString()))];

    const handleChangeYear = (event) => {
        setSelectedYear(event.target.value);
    };

    const handleChangeMonth = (event) => {
        const monthValue = event.target.value;
        setSelectedMonth(monthValue.padStart(2, '0'));
    };

    const handleRegionChange = (selectedOptions) => {
        if (selectedOptions.length > 4) {
            setRegionError('You can select a maximum of 4 regions.');
            return;
        }
        setSelectedRegions(selectedOptions);
        if (selectedOptions.length < 2) {
            setRegionError('Please select at least 2 regions to compare.');
        } else {
            setRegionError('');
        }
    };

    const filteredEntries = getFilteredData();
    const monthlySalesCount = calculateMonthlySales(filteredEntries);
    console.log("monthlySalesCount",monthlySalesCount)
    const sortedMonths = Object.keys(monthlySalesCount).sort();

    const filteredEntriesForDay = getFilteredEntriesForDay();
    const dailySalesCount = calculateDailySales(filteredEntriesForDay);
    const daysInSelectedMonth = Array.from({ length: new Date(selectedYear, selectedMonth, 0).getDate() }, (_, i) => i + 1);

    const chartData = {
  labels: sortedMonths,
  datasets:
    chartType === 'bar'
      ? [
          {
            label: 'Monthly Sales Count',
            data: sortedMonths.map(
              (month) => monthlySalesCount[month].count
            ),
            backgroundColor: '#ADD8E6',
            borderColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 1,
            barThickness: isMobile ? 10 : 30,
          },
        ]
      : [
          {
            label: 'Sales Count',
            data: sortedMonths.map(
              (month) => monthlySalesCount[month].count
            ),
            borderColor: '#2563eb',
            backgroundColor: '#2563eb',
            tension: 0.3,
            yAxisID: 'y',
             pointRadius: 4,
            pointHoverRadius: 6,
          },
          {
            label: 'Revenue',
            data: sortedMonths.map(
              (month) => monthlySalesCount[month].totalAmount
            ),
            borderColor: '#16a34a',
            backgroundColor: '#16a34a',
            tension: 0.2,
            yAxisID: 'y1',
            //  borderDash: [6, 6],
              pointRadius: 4, 
          },
        ],
};

  const monthlychartOptions = {
  responsive: true,
  maintainAspectRatio: false,

  scales: {
 y: {
    beginAtZero: true,
    title: {
      display: true,
      text: 'Sales Count',
    },

    ...(chartType !== 'bar' && {
      min: 0,
      max: 500,
    }),
  },
  y1: {
    beginAtZero: true,
    position: 'right',
    grid: {
      drawOnChartArea: false, // prevents grid overlap
    },
    title: {
      display: true,
      text: 'Revenue (₹)',
    },
    ticks: {
      callback: (value) => formatCurrency(value),
    },
  },
},

  plugins: {
    datalabels: {
    display: false,
  },
    tooltip: {
      callbacks: {
        label: function (context) {
          const month = context.label;
          if (monthlySalesCount && monthlySalesCount[month]) {
            const salesCount = monthlySalesCount[month].count;
            const totalAmount = monthlySalesCount[month].totalAmount;
  
            return [
              `Sales Count: ${salesCount}`,
              `Revenue: ${formatCurrency(totalAmount.toFixed(2))}`,
            ];
          }

          if (context.dataset.label && context.parsed?.y) {
            return `${context.dataset.label}: ${formatCurrency(context.parsed.y)}`;
          }
  
          return context.label;
        },
      },
    },
    legend: {
      position: 'bottom',
    },
  },
};


    const dayWiseChartData = {
        labels: daysInSelectedMonth.map(day => `${selectedYear}-${selectedMonth}-${day.toString().padStart(2, '0')}`),
        datasets: [
            {
                label: 'Daily Sales Count',
                data: daysInSelectedMonth.map(day => dailySalesCount[`${selectedYear}-${selectedMonth}-${day.toString().padStart(2, '0')}`] || 0),
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                borderColor: 'rgba(255, 99, 132, 1)',
                borderWidth: 1,
            }
        ],
    };

    const chartOptions = {
        scales: {
            y: { beginAtZero: true }
        },
        plugins: {
            legend: { display: true, position: 'bottom' }
        },
        responsive: true,
        maintainAspectRatio: false
    };

//filtered regional entries based on selected year and month
    const filteredRegionalEntries = useMemo(() => {
  return salesEntries.filter(entry => {
    const entryDate = new Date(entry.createdAt);
    // console.log("entryDate selectedSalesByRegionYear",entryDate,selectedSalesByRegionYear,selectedSalesByRegionMonth)

    return( (selectedSalesByRegionYear==='ALL'?true:entryDate.getFullYear() === parseInt(selectedSalesByRegionYear)
    ) &&
      (selectedSalesByRegionMonth
        ? entryDate.getMonth() + 1 === parseInt(selectedSalesByRegionMonth)
        : true)
    );
  });
}, [salesEntries, selectedSalesByRegionYear, selectedSalesByRegionMonth,fromDate,toDate]);

//Aggregate filtered data by Region

const regionalAggregatedData = useMemo(() => {
 
  return filteredRegionalEntries.reduce((acc, entry) => {
    // const region = entry.Region; // 👈 update if your key is different
    // console.log("filteredRegionalEntries",filteredRegionalEntries)
    const codeId = Number(entry.RegionalCodeId);
const region = regionLabelMap[codeId] || 'Rest of India';
    const paymentAmount = entry.PaymentAmount || 0;
    const refundAmount = entry.RefundDetails?.RefundAmount || 0;

    const netAmount = paymentAmount - refundAmount;

    if (!acc[region]) {
      acc[region] = { revenue: 0, count: 0 };
    }

    acc[region].revenue += netAmount;
    acc[region].count += 1;

    return acc;
  }, {});
}, [filteredRegionalEntries]);

const sortedRegionalData = useMemo(() => {
  return Object.entries(regionalAggregatedData)
    .map(([region, data]) => ({
      region,
      revenue: data.revenue,
      count: data.count,
    }))
    .sort((a, b) => b.revenue - a.revenue); // 🔥 highest revenue first
}, [regionalAggregatedData]);


const regionalLabels = useMemo(
  () => sortedRegionalData.map(item => item.region),
  [sortedRegionalData]
);
    console.log("regionalAggregatedData",sortedRegionalData)
    console.log("regionalAggregatedData1",regionalLabels)

    


const regionalSalesCounts = useMemo(
  () => Object.values(sortedRegionalData).map(item => item.count),
  [sortedRegionalData]
);

const regionalSalesRevenue = useMemo(
  () => Object.values(sortedRegionalData).map(item => item.revenue),
  [sortedRegionalData]
);

// Debug: show which cities/codes are falling into "Rest of India"
const restOfIndiaBreakdown = useMemo(() => {
  const cityMap = {};
  filteredRegionalEntries.forEach(entry => {
    const codeId = Number(entry.RegionalCodeId);
    if (!regionLabelMap[codeId]) {
      const city = entry.City || entry.HospitalClinicName || `Code ${codeId}`;
      const key = `${city} (Code: ${codeId})`;
      cityMap[key] = (cityMap[key] || 0) + 1;
    }
  });
  return Object.entries(cityMap).sort((a, b) => b[1] - a[1]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [filteredRegionalEntries, regionLabelMapFromAPI]);

console.log('Rest of India breakdown (unmapped codes):', restOfIndiaBreakdown);


    const validatedRegionalLabels = regionalLabels.length > 0 ? regionalLabels : ['No Data'];
const validatedRegionalSalesCounts = regionalSalesCounts.length > 0 ? regionalSalesCounts : [0];
const validatedRegionalSalesRevenue=regionalSalesRevenue.length>0?regionalSalesRevenue:[0];
    
    // const borderColors = [
    //     'rgba(0, 0, 255, 0.6)',    // Blue
    //     // 'rgba(54, 162, 235, 1)',
    //     // 'rgba(255, 206, 86, 1)',
    //     // 'rgba(75, 192, 192, 1)',
    // ];

 // Generate backgroundColor and borderColor arrays dynamically
 const dynamicColors = validatedRegionalLabels.map((_, i) => colors[i % colors.length]);
 const donutbackgroundColors = validatedRegionalLabels.map((_, i) => colors[i % colors.length]);
//  const borderColorsDynamic = validatedRegionalLabels.map((_, i) => borderColors[i % borderColors.length]);
 

    // Build chart data
    const regionalDonutChartData = useMemo(() => ({
        labels: validatedRegionalLabels,
        datasets: [
            {
                label: 'Sales by Region',
                // dataSalesCount: validatedRegionalSalesCounts,
                data:validatedRegionalSalesRevenue,
                counts: validatedRegionalSalesCounts,
                backgroundColor: dynamicColors,
                // borderColor: [...borderColorsDynamic],
                borderWidth: 1,
                spacing: 5,
               
            },
           
        ],
    }), [validatedRegionalLabels, validatedRegionalSalesCounts, donutbackgroundColors,validatedRegionalSalesCounts,validatedRegionalSalesRevenue,
  dynamicColors]);
    
   
    const regionalDonutChartOptions = {
        responsive: true,
        plugins: {
            textInside: true,
            legend: {
                position: 'bottom',
                labels: isMobile?{
                    boxWidth: 8,
                    font: {
                        size: 11,
                        family: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                        weight: '600',
                    },
                    padding: 16,
                    usePointStyle: true,
                    textAlign: 'left',
                    color: '#1f2937',
                }:{
                    boxWidth: 14,
                    font: {
                        size: 13,
                        family: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                        weight: '600',
                    },
                    padding: 18,
                    usePointStyle: true,
                    color: '#1f2937',
                },
            },
            tooltip: {
                backgroundColor: 'rgba(30, 60, 114, 0.95)',
                padding: 14,
                titleFont: {
                    size: 13,
                    weight: 'bold',
                    family: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                },
                bodyFont: {
                    size: 12,
                    family: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                },
                borderColor: '#34d399',
                borderWidth: 2,
                callbacks: {
                    label: (tooltipItem) => {
                        const regionLabel = validatedRegionalLabels[tooltipItem.dataIndex];
                        const count = validatedRegionalSalesCounts[tooltipItem.dataIndex];
                        const revenue= validatedRegionalSalesRevenue[tooltipItem.dataIndex];
                        return [`${regionLabel}: ${count} Sales`,
                                `Revenue: ${formatCurrency(revenue)}`
                        ];
                    },
                },
            },
            datalabels: {
                display: false,
            },
        },
        rotation: -90,
        circumference: 180,
        cutout: '60%',
        hover: {
            onHover: function (event, elements, chart) {
                if (elements.length) {
                    chart.canvas.style.cursor = 'pointer';
                } else {
                    chart.canvas.style.cursor = 'default';
                }
            },
        },
        animation: {
            duration: 1200,
            easing: 'easeInOutQuad',
        },
        scales: {},
    };

//filtered sales-person entries based on selected year and month (follows the same fromDate/toDate global filter as Sales by Region)
    const filteredSalesPersonEntries = useMemo(() => {
  return salesEntries.filter(entry => {
    const entryDate = new Date(entry.createdAt);

    return( (selectedSalesBySalesPersonYear==='ALL'?true:entryDate.getFullYear() === parseInt(selectedSalesBySalesPersonYear)
    ) &&
      (selectedSalesBySalesPersonMonth
        ? entryDate.getMonth() + 1 === parseInt(selectedSalesBySalesPersonMonth)
        : true)
    );
  });
}, [salesEntries, selectedSalesBySalesPersonYear, selectedSalesBySalesPersonMonth,fromDate,toDate]);

//Aggregate filtered data by Sales Person
const salesPersonAggregatedData = useMemo(() => {
  return filteredSalesPersonEntries.reduce((acc, entry) => {
    const salesPerson = entry.SalesPerson || 'Unassigned';
    const paymentAmount = entry.PaymentAmount || 0;
    const refundAmount = entry.RefundDetails?.RefundAmount || 0;

    const netAmount = paymentAmount - refundAmount;

    if (!acc[salesPerson]) {
      acc[salesPerson] = { revenue: 0, count: 0 };
    }

    acc[salesPerson].revenue += netAmount;
    acc[salesPerson].count += 1;

    return acc;
  }, {});
}, [filteredSalesPersonEntries]);

const sortedSalesPersonData = useMemo(() => {
  return Object.entries(salesPersonAggregatedData)
    .map(([salesPerson, data]) => ({
      salesPerson,
      revenue: data.revenue,
      count: data.count,
    }))
    .sort((a, b) => b.revenue - a.revenue); // highest revenue first
}, [salesPersonAggregatedData]);

const salesPersonLabels = useMemo(
  () => sortedSalesPersonData.map(item => item.salesPerson),
  [sortedSalesPersonData]
);

const salesPersonSalesCounts = useMemo(
  () => Object.values(sortedSalesPersonData).map(item => item.count),
  [sortedSalesPersonData]
);

const salesPersonSalesRevenue = useMemo(
  () => Object.values(sortedSalesPersonData).map(item => item.revenue),
  [sortedSalesPersonData]
);

    const validatedSalesPersonLabels = salesPersonLabels.length > 0 ? salesPersonLabels : ['No Data'];
const validatedSalesPersonSalesCounts = salesPersonSalesCounts.length > 0 ? salesPersonSalesCounts : [0];
const validatedSalesPersonSalesRevenue = salesPersonSalesRevenue.length>0?salesPersonSalesRevenue:[0];

 const dynamicColorsSalesPerson = validatedSalesPersonLabels.map((_, i) => colors[i % colors.length]);

    // Build chart data
    const salesPersonDonutChartData = useMemo(() => ({
        labels: validatedSalesPersonLabels,
        datasets: [
            {
                label: 'Sales by Sales Person',
                data: validatedSalesPersonSalesRevenue,
                counts: validatedSalesPersonSalesCounts,
                backgroundColor: dynamicColorsSalesPerson,
                borderWidth: 1,
                spacing: 5,
            },
        ],
    }), [validatedSalesPersonLabels, validatedSalesPersonSalesCounts, validatedSalesPersonSalesRevenue,
  dynamicColorsSalesPerson]);

    const salesPersonDonutChartOptions = {
        responsive: true,
        plugins: {
            textInside: true,
            legend: {
                position: 'bottom',
                labels: isMobile?{
                    boxWidth: 8,
                    font: {
                        size: 11,
                        family: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                        weight: '600',
                    },
                    padding: 16,
                    usePointStyle: true,
                    textAlign: 'left',
                    color: '#1f2937',
                }:{
                    boxWidth: 14,
                    font: {
                        size: 13,
                        family: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                        weight: '600',
                    },
                    padding: 18,
                    usePointStyle: true,
                    color: '#1f2937',
                },
            },
            tooltip: {
                backgroundColor: 'rgba(30, 60, 114, 0.95)',
                padding: 14,
                titleFont: {
                    size: 13,
                    weight: 'bold',
                    family: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                },
                bodyFont: {
                    size: 12,
                    family: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                },
                borderColor: '#34d399',
                borderWidth: 2,
                callbacks: {
                    label: (tooltipItem) => {
                        const salesPersonLabel = validatedSalesPersonLabels[tooltipItem.dataIndex];
                        const count = validatedSalesPersonSalesCounts[tooltipItem.dataIndex];
                        const revenue= validatedSalesPersonSalesRevenue[tooltipItem.dataIndex];
                        return [`${salesPersonLabel}: ${count} Sales`,
                                `Revenue: ${formatCurrency(revenue)}`
                        ];
                    },
                },
            },
            datalabels: {
                display: false,
            },
        },
        rotation: -90,
        circumference: 180,
        cutout: '60%',
        hover: {
            onHover: function (event, elements, chart) {
                if (elements.length) {
                    chart.canvas.style.cursor = 'pointer';
                } else {
                    chart.canvas.style.cursor = 'default';
                }
            },
        },
        animation: {
            duration: 1200,
            easing: 'easeInOutQuad',
        },
        scales: {},
    };

    //top 5 hospital revenue
    const top5Hospitals = useMemo(() => {
        const filteredEntries = salesEntries.filter(entry => {
            const entryDate = new Date(entry.createdAt);
            // console.log("hospital data")
            // console.log("hospital selected year",entryDate.getFullYear(),entryDate.getMonth(),selectedHospitalMonth,selectedHospitalYear)
           const yearMatch =
      selectedHospitalYear === "ALL"
        ? true
        : entryDate.getFullYear() === parseInt(selectedHospitalYear);

    const monthMatch =
      selectedHospitalMonth
        ? entryDate.getMonth() + 1 === parseInt(selectedHospitalMonth)
        : true;

    return yearMatch && monthMatch;
            // return (
            //     entryDate.getFullYear() === parseInt(selectedHospitalYear) &&
            //     (selectedHospitalMonth ? entryDate.getMonth() + 1 === parseInt(selectedHospitalMonth) : true)
            // );
        });
        console.log("filteredEntries",filteredEntries)
        const hospitalRevenue = filteredEntries.reduce((acc, entry) => {
            const { HospitalClinicName, PaymentAmount} = entry; // Replace with actual keys
            const refundAmount = entry.RefundDetails?.RefundAmount || 0; 
            const netAmount = (PaymentAmount || 0) - refundAmount;
            acc[HospitalClinicName] = (acc[HospitalClinicName] || 0) + netAmount;
            return acc;
        }, {});
        console.log("hospitalRevenue",hospitalRevenue)
    
        const sortedHospitals = Object.entries(hospitalRevenue)
            .sort((a, b) => b[1] - a[1])
            .slice(0, 5);
    
        return sortedHospitals.map(([HospitalClinicName, PaymentAmount]) => ({ HospitalClinicName, PaymentAmount }));
    }, [salesEntries, selectedHospitalYear, selectedHospitalMonth]);
    console.log("top5Hospitals",top5Hospitals)

    //top5 hospital chart data
    const top5ChartData = {
        labels: top5Hospitals.map(hospital => hospital.HospitalClinicName),
        datasets: [
            {
                label: 'Revenue (in Rs) ₹',
                data: top5Hospitals.map(hospital => hospital.PaymentAmount),
                backgroundColor: [
                    '#34d399', // Teal Green
                    '#0891b2', // Cyan Teal
                    '#06b6d4', // Sky Cyan
                    '#10b981', // Emerald
                    '#14b8a6', // Turquoise
                    '#2a5298', // Navy
                    '#1e40af', // Deep Blue
                ],
                borderColor: [
                    'rgb(255, 255, 255)'
                ],
                borderWidth: 2,
            },
        ],
    };

    const top5ChartOptions = {
        indexAxis: 'y',
        scales: {
            x: {
                beginAtZero: true,
                title: {
                    display: true,
                    text: 'Revenue (in Rs)',
                    font: {
                        size: 14,
                        weight: 'bold',
                        family: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                    },
                    color: '#1e3c72',
                },
                ticks: {
                    color: '#1f2937',
                    font: {
                        size: 12,
                        family: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                    },
                },
                grid: {
                    color: 'rgba(52, 211, 153, 0.1)',
                },
            },
            y: {
                ticks: {
                    display: true,
                    color: '#1f2937',
                    font: {
                        size: 12,
                        weight: '600',
                        family: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                    },
                },
                grid: {
                    display: false,
                },
            },
        },
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                backgroundColor: 'rgba(30, 60, 114, 0.9)',
                padding: 12,
                titleFont: {
                    size: 13,
                    weight: 'bold',
                    family: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                },
                bodyFont: {
                    size: 12,
                    family: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                },
                borderColor: '#34d399',
                borderWidth: 2,
                displayColors: true,
                callbacks: {
                    title: (tooltipItems) => tooltipItems[0].label,
                    label: (context) => `Revenue: ₹${context.parsed.x.toLocaleString()}`,
                },
            },
            datalabels: {
                align: 'end',
                anchor: 'start',
                formatter: (value, context) => {
                    return `₹${(value / 1000).toFixed(1)}K`;
                },
                color: '#1e3c72',
                font: {
                    size: 11,
                    weight: 'bold',
                    family: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                },
                offset: 8,
            },
        },
        responsive: true,
        maintainAspectRatio: false,
    };


//filter by month and year
const testfilteredEntries = useMemo(() => {
  return salesEntries.filter(entry => {
    const entryDate = new Date(entry.createdAt);
    const entryYear = entryDate.getFullYear().toString();
    const entryMonth = (entryDate.getMonth() + 1).toString().padStart(2, '0');

    const yearMatches = selectedYear ? entryYear === selectedYear : true;
    const monthMatches = selectedMonth ? entryMonth === selectedMonth : true;

    return yearMatches && monthMatches;
  });
}, [salesEntries, selectedYear, selectedMonth]);
    
//Top 5 tests
const top5TestsByCount = useMemo(() => {
  const testCountMap = {};

  // Filter sales entries by selected year and month
  const filteredEntries = salesEntries.filter(entry => {
    const entryDate = new Date(entry.createdAt); // Adjust if your date field is named differently
    //console.log("entryDate",entryDate)
    const year = entryDate.getFullYear().toString();
    const month = (entryDate.getMonth() + 1).toString().padStart(2, '0');

    const yearMatches =testselectedYear==='ALL'?true: year === testselectedYear;
    const monthMatches = !testselectedMonth || month === testselectedMonth;

    return yearMatches && monthMatches;
  });
//   console.log("TestfilteredEntries",filteredEntries)

  // Count tests
  filteredEntries.forEach(entry => {
    if (entry.tests && Array.isArray(entry.tests)) {
      entry.tests.forEach(test => {
        const testName = test.test || "Unknown Test";
        testCountMap[testName] = (testCountMap[testName] || 0) + 1;
      });
    }
  });

  // Sort and take top 5
  const sortedTests = Object.entries(testCountMap)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 10);

  return sortedTests.map(([testName, count]) => ({ testName, count }));
}, [salesEntries, testselectedYear, testselectedMonth]);


const top5TestsByCountChartData = {
  labels: top5TestsByCount.map(t => t.testName),
  datasets: [
    {
      label: 'Test Count',
      data: top5TestsByCount.map(t => t.count),
      backgroundColor: [
        '#34d399', // Teal Green
        '#0891b2', // Cyan Teal
        '#06b6d4', // Sky Cyan
        '#10b981', // Emerald
        '#14b8a6', // Turquoise
        '#2a5298', // Navy Blue
        '#1e40af', // Deep Blue
        '#0369a1', // Deep Sky Blue
        '#0f766e', // Dark Teal
        '#115e59', // Teal Dark
      ],
      borderColor: ['rgb(255, 255, 255)'],
      borderWidth: 2,
    },
  ],
};

const top5TestsByCountChartOptions = {
  indexAxis: 'y',
  scales: {
    x: {
      beginAtZero: true,
      title: {
        display: true,
        text: 'Test Count',
        font: {
          size: 14,
          weight: 'bold',
          family: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        },
        color: '#1e3c72',
      },
      ticks: {
        color: '#1f2937',
        font: {
          size: 12,
          family: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        },
      },
      grid: {
        color: 'rgba(52, 211, 153, 0.1)',
      },
    },
    y: {
      ticks: {
      
        display: true,
        color: '#1f2937',
        font: {
          size: 12,
          weight: '600',
          family: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        },
        padding: 10,
        callback: function(value) {
          const label = this.getLabelForValue(value);
          const maxLength = 26;
          if (label.length > maxLength) {
            return label.substring(0, maxLength) + '...';
          }
          return label;
        },
      },
      grace: '4%',
    },
  },
  layout: {
    padding: {
      left: -20,
      right: 10,
      top: 10,
      bottom: 10,
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      backgroundColor: 'rgba(30, 60, 114, 0.9)',
      padding: 12,
      titleFont: {
        size: 13,
        weight: 'bold',
        family: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      },
      bodyFont: {
        size: 12,
        family: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      },
      borderColor: '#34d399',
      borderWidth: 2,
      displayColors: true,
      callbacks: {
        title: (tooltipItems) => tooltipItems[0].label,
        label: (context) => `Count: ${context.parsed.x}`,
      },
    },
    datalabels: {
      align: 'end',
      anchor: 'start',
      formatter: (value) => {
        return value.toString();
      },
      color: '#1e3c72',
      font: {
        size: 11,
        weight: 'bold',
        family: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      },
      offset: 8,
    },
  },
  responsive: true,
  maintainAspectRatio: false,
};

    return (

        <div className="dashboard-container">

            {/*  Top Bar: Sidebar Label + Date Filters  */}
            <div className="dashboard-topbar">
                <div className="dashboard-brand">
                    <div className="dashboard-brand-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M3 3v18h18"/>
                            <path d="M18 9l-5 5-2.5-2.5L7 15"/>
                            <circle cx="18" cy="9" r="1.5" fill="currentColor"/>
                        </svg>
                    </div>
                    <div>
                        <h1 className="dashboard-brand-title">Sales Dashboard</h1>
                        <p className="dashboard-brand-sub">Real-time analytics & performance insights</p>
                    </div>
                </div>
                <div className="dashboard-filters">
                    <div className="date-group">
                        <label>From</label>
                        <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} className="date-input" />
                    </div>
                    <div className="date-group">
                        <label>To</label>
                        <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} className="date-input" />
                    </div>
                    {(fromDate || toDate) && (
                        <button className="clear-filter-btn" onClick={() => { setFromDate(''); setToDate(''); }}>
                             Clear
                        </button>
                    )}
                </div>
            </div>

            {/*  KPI Cards  */}
            {/* <p className="section-label">Overview</p> */}
            <div className="dashboard-cards">
                <div className="dashboard-card">
                    <SalesOverviewCard totalSales={totalSales} totalTests={totalTests} totalAmount={totalAmount} isLoading={loading} />
                </div>
                <div className="dashboard-card">
                    <DailySalesOverviewCard TodaystotalSales={todaySales} TodaystotalTests={todayTests} TodaystotalAmount={todayAmount} salesPercentageChange={dailySalesPercentageChange} amountPercentageChange={dailyAmountPercentageChange} isLoading={loading} />
                </div>
                <div className="dashboard-card">
                    <MonthlySalesOverviewCard currentMonthSales={currentMonthSales} currentMonthAmount={currentMonthAmount} currentMonthTests={currentMonthTests} salesPercentageChange={monthlySalesPercentageChange} amountPercentageChange={monthlyAmountPercentageChange} isLoading={loading} />
                </div>
            </div>

            {/*  Charts Row: Region  Top Hospitals  Top Tests  */}
            {/* <p className="section-label">Analytics</p> */}
            <div className="secondrow">
                <div className="secondrowcard">
                    <h3>Sales by Region</h3>
                    <div className="chart-controls">
                        <div>
                            <label>Year</label>
                            <select value={selectedSalesByRegionYear} onChange={(e) => setSelectedSalesByRegionYear(e.target.value)}>
                                <option value="ALL">All Years</option>
                                {years.map(year => <option key={year} value={year}>{year}</option>)}
                            </select>
                        </div>
                        <div>
                            <label>Month</label>
                            <select value={selectedSalesByRegionMonth} onChange={(e) => setSelectedSalesByRegionMonth(e.target.value)}>
                                <option value="">All Months</option>
                                {Array.from({ length: 12 }, (_, i) => { const v = (i+1).toString().padStart(2,'0'); return <option key={v} value={v}>{new Date(0,i).toLocaleString('default',{month:'long'})}</option>; })}
                            </select>
                        </div>
                    </div>
                    <div className="doughnut-wrapper">
                        <Doughnut data={regionalDonutChartData} options={regionalDonutChartOptions} />
                    </div>
                    {restOfIndiaBreakdown.length > 0 && (
                        <details style={{ marginTop: 10, fontSize: 12 }}>
                            <summary style={{ cursor: 'pointer', color: '#0369a1', fontWeight: 600 }}>
                                Rest of India — {restOfIndiaBreakdown.reduce((s, [, c]) => s + c, 0)} entries ({restOfIndiaBreakdown.length} cities/codes)
                            </summary>
                            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 6 }}>
                                <thead>
                                    <tr style={{ background: '#f1f5f9' }}>
                                        <th style={{ textAlign: 'left', padding: '4px 8px', fontSize: 11 }}>City (Regional Code)</th>
                                        <th style={{ textAlign: 'right', padding: '4px 8px', fontSize: 11 }}>Entries</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {restOfIndiaBreakdown.map(([label, count]) => (
                                        <tr key={label} style={{ borderBottom: '1px solid #e2e8f0' }}>
                                            <td style={{ padding: '3px 8px' }}>{label}</td>
                                            <td style={{ padding: '3px 8px', textAlign: 'right' }}>{count}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </details>
                    )}
                </div>

                <div className="secondrowcard">
                    <h3>Sales by Sales Person</h3>
                    <div className="chart-controls">
                        <div>
                            <label>Year</label>
                            <select value={selectedSalesBySalesPersonYear} onChange={(e) => setSelectedSalesBySalesPersonYear(e.target.value)}>
                                <option value="ALL">All Years</option>
                                {years.map(year => <option key={year} value={year}>{year}</option>)}
                            </select>
                        </div>
                        <div>
                            <label>Month</label>
                            <select value={selectedSalesBySalesPersonMonth} onChange={(e) => setSelectedSalesBySalesPersonMonth(e.target.value)}>
                                <option value="">All Months</option>
                                {Array.from({ length: 12 }, (_, i) => { const v = (i+1).toString().padStart(2,'0'); return <option key={v} value={v}>{new Date(0,i).toLocaleString('default',{month:'long'})}</option>; })}
                            </select>
                        </div>
                    </div>
                    <div className="doughnut-wrapper">
                        <Doughnut data={salesPersonDonutChartData} options={salesPersonDonutChartOptions} />
                    </div>
                </div>

                <div className="secondrowcard">
                    <h3>Top 5 Hospitals by Revenue</h3>
                    <div className="chart-controls">
                        <div>
                            <label>Year</label>
                            <select value={selectedHospitalYear} onChange={(e) => setSelectedHospitalYear(e.target.value)}>
                                <option value="ALL">All Years</option>
                                {years.map(year => <option key={year} value={year}>{year}</option>)}
                            </select>
                        </div>
                        <div>
                            <label>Month</label>
                            <select value={selectedHospitalMonth} onChange={(e) => setSelectedHospitalMonth(e.target.value)}>
                                <option value="">All Months</option>
                                {Array.from({ length: 12 }, (_, i) => { const v = (i+1).toString().padStart(2,'0'); return <option key={v} value={v}>{new Date(0,i).toLocaleString('default',{month:'long'})}</option>; })}
                            </select>
                        </div>
                    </div>
                    <div className="chart-wrapper" style={{ height: '400px' }}>
                        {top5Hospitals.length ? <Bar data={top5ChartData} options={top5ChartOptions} /> : <p style={{ color:'#64748b',fontWeight:'500' }}>No data available.</p>}
                    </div>
                </div>

                <div className="secondrowcard">
                    <h3>Top 10 Tests by Count</h3>
                    <div className="chart-controls">
                        <div>
                            <label>Year</label>
                            <select value={testselectedYear} onChange={(e) => testsetSelectedYear(e.target.value)}>
                                <option value="ALL">All Years</option>
                                {years.map(year => <option key={year} value={year}>{year}</option>)}
                            </select>
                        </div>
                        <div>
                            <label>Month</label>
                            <select value={testselectedMonth} onChange={(e) => testsetSelectedMonth(e.target.value)}>
                                <option value="">All Months</option>
                                {Array.from({ length: 12 }, (_, i) => { const v = (i+1).toString().padStart(2,'0'); return <option key={v} value={v}>{new Date(0,i).toLocaleString('default',{month:'long'})}</option>; })}
                            </select>
                        </div>
                    </div>
                    <div className="chart-wrapper" style={{ height: `${Math.max(450, top5TestsByCount.length * 55)}px` }}>
                        {top5TestsByCount.length ? <Bar data={top5TestsByCountChartData} options={top5TestsByCountChartOptions} /> : <p style={{ color:'#64748b',fontWeight:'500' }}>No test data available.</p>}
                    </div>
                </div>
            </div>

            {/*  Trends Section  */}
            {error && <p className="error">{error}</p>}
            {loading ? (
                <div className="loading-spinner">Loading charts...</div>
            ) : (
                <>
                    {/* <p className="section-label">Trends</p> */}

                    {/* Monthly Sales */}
                    <div className="thirdrowcard" style={{ marginBottom:'16px' }}>
                         <p className="section-label">Monthly Sales Data</p>
                        <div className="monthly-toolbar">
                            <div className="monthly-toolbar-left">
                                {/* <h3 style={{ margin:0 }}>Monthly Sales</h3> */}
                                <div className="chart-controls" style={{
    margin: 0,
    display: "flex",
    gap: "20px",
    alignItems: "center"
  }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" ,flexDirection:"row"}}>
                                        <label>Year</label>
                                        <select value={selectedYear} onChange={handleChangeYear}>
                                            {years.map(year => <option key={year} value={year}>{year}</option>)}
                                        </select>
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px",flexDirection:"row" }}>
                                        <label >Month</label>
                                        <select value={selectedMonth} onChange={handleChangeMonth}>
                                            <option value="">All Months</option>
                                            {Array.from({ length: 12 }, (_, i) => { const v = (i+1).toString().padStart(2,'0'); return <option key={v} value={v}>{new Date(0,i).toLocaleString('default',{month:'long'})}</option>; })}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="monthly-toolbar-right">
                                <button onClick={() => setChartType('bar')} className={`chart-button ${chartType==='bar'?'activeBtn':''}`}>Bar</button>
                                <button onClick={() => setChartType('line')} className={`chart-button ${chartType==='line'?'activeBtn':''}`}>Line</button>
                            </div>
                        </div>
                        <div style={{ height:'400px' }}>
                            {chartType === 'bar' ? <Bar data={chartData} options={monthlychartOptions} /> : <Line data={chartData} options={monthlychartOptions} />}
                        </div>
                    </div>

                    {/* Day-Wise */}
                    {selectedMonth && (
                        <div className="thirdrowcard" style={{ marginBottom:'16px' }}>
                            <h3>Day-Wise Sales</h3>
                            <div style={{ height:'400px' }}>
                                <Bar data={dayWiseChartData} options={chartOptions} />
                            </div>
                        </div>
                    )}

                    {/* Regional Comparison */}
                    {(userRole==="admin"||userRole==="Super_Admin")&&
                    (<div className="thirdrowcard" style={{ marginBottom:'24px' }}>
                        <div className="regional-comparison-header">
                            <h3>Regional Sales Comparison</h3>
                            <div className="regional-filters">
                                <div className="filter-item">
                                    <label>Year</label>
                                    <select value={regionalComparisonYear} onChange={(e) => setRegionalComparisonYear(e.target.value)}>
                                        <option value="ALL">All Years</option>
                                        {years.map(year => <option key={year} value={year}>{year}</option>)}
                                    </select>
                                </div>
                                <div className="filter-item">
                                    <label>Month</label>
                                    <select value={regionalComparisonMonth} onChange={(e) => setRegionalComparisonMonth(e.target.value)}>
                                        <option value="">All Months</option>
                                        {Array.from({ length: 12 }, (_, i) => { const v = (i+1).toString().padStart(2,'0'); return <option key={v} value={v}>{new Date(0,i).toLocaleString('default',{month:'long'})}</option>; })}
                                    </select>
                                </div>
                                <div className="filter-item" style={{ minWidth:'200px' }}>
                                    <label>Regions</label>
                                    <ReactSelect
                                        isMulti
                                        options={uniqueRegions.map(r => ({ value:r, label:r }))}
                                        value={selectedRegions}
                                        onChange={handleRegionChange}
                                        className="region-select"
                                        placeholder="Select regions"
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        components={{ Option: CustomOption }}
                                    />
                                </div>
                            </div>
                        </div>
                        {regionError && <p style={{ color:'#ef4444', fontSize:'13px', marginBottom:'8px' }}>{regionError}</p>}
                        <div className="chart-wrapper" style={{ height:'400px', marginTop:'12px' }}>
                            {selectedRegions.length < 2 ? (
                                <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', height:'100%' }}>
                                    <img src={PlaceholderImage} alt="Select regions" style={{ opacity:0.55, maxHeight:'160px' }} />
                                    <p style={{ marginTop:'14px', color:'#94a3b8', fontWeight:'500', fontSize:'14px' }}>Select at least 2 regions to see a comparison.</p>
                                </div>
                            ) : (
                                <Line data={regionalComparisonChartData} options={monthlychartOptions} />
                            )}
                        </div>
                    </div>)}
                </>
            )}
        </div>
    );
};

export default DashboardPage;
